// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyCameraDisabledSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.207 3h5.586a.5.5 0 0 1 .353.146L17 5h.8c1.12 0 2.68 0 3.108.218a2 2 0 0 1 .874.874C22 6.52 22 7.08 22 8.2v9.6c0 1.12 0 1.68-.218 2.108-.06.118-.131.229-.212.331l-5.066-5.066a5.002 5.002 0 0 0-6.677-6.677L6.33 5H7l1.854-1.854A.5.5 0 0 1 9.207 3zM3.415 5.122 2.177 3.884a.25.25 0 0 1 0-.354l.353-.353a.25.25 0 0 1 .354 0l17.792 17.792a.25.25 0 0 1 0 .353l-.354.354a.25.25 0 0 1-.353 0l-.677-.677L18.8 21H6.2c-1.12 0-2.68 0-3.108-.218a2 2 0 0 1-.874-.874C2 19.48 2 18.92 2 17.8V8.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.075-.038.186-.07.323-.096zm10.323 10.323a3.001 3.001 0 0 1-4.183-4.183L8.129 9.836a5.002 5.002 0 0 0 7.035 7.035zM15 13c0 .208-.021.411-.062.608l-3.546-3.546A3.001 3.001 0 0 1 15 13z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyCameraDisabledSolid;
